import { Injectable } from '@angular/core';
import { AuthAdapter } from './auth-adapter';
import { LocalStorageService } from '../../../services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ByPass implements AuthAdapter {
  public user;
  constructor(private localStorage: LocalStorageService) {
  }

  public login(data) {
    this.localStorage.setItem('user', JSON.stringify(data));
    return Promise.resolve(true);
  }

  public logout() {
    this.localStorage.removeItem('user');
    return Promise.resolve(true);
  }

  public isAuthenticated() {
    return !!this.localStorage.getItem('user');
  }

  public getUserInfo() {
    return Promise.resolve(JSON.parse(this.localStorage.getItem('user')));
  }

  public getToken() {
    return '';
  }

  public getUsername() {
    return 'bypass';
  }
}
